export class MaterialPreviewDialogResult {
	previewUrl: string | undefined;
	externalMaterialUploaderRequested: boolean = false;
}
